








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-question-white',

})
export default class IQuestionWhite extends Vue {

  @Prop({type: [String], default: '#2D9CDB'}) protected color!: string

}

